// extracted by mini-css-extract-plugin
module.exports = {"wrap":"BrowserNotSupportedView_wrap__1Co1t","content":"BrowserNotSupportedView_content__4BxvR","action":"BrowserNotSupportedView_action__142Mw"};